import {MAX_WIDTH, WIDTH_RATIO} from '../Gallery.definition';

export const calcAvailableWidth = ({screen, widthRatio = WIDTH_RATIO}) =>
  (screen.width <= MAX_WIDTH ? screen.width : MAX_WIDTH) * widthRatio;
